import { createFileRoute } from '@tanstack/react-router'
import EncountersPage from '~/features/dashboard/pages/urgent-care/encounters'
import { z } from "zod"
// import { encountersQueryOptions,encounterQueryOptions ,chatHistoryQueryOptions,appointmentsQueryOptions} from "./api/queries"
// Define the search schema for this route
const encountersSearchSchema = z.object({
  session_id: z.string().optional(),
})
 
export const Route = createFileRoute(
  '/(dashboard)/dashboard/urgent-care/encounters/',
)({
  component: RouteComponent,
  validateSearch: encountersSearchSchema,
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
 <h1 className="text-2xl font-bold">Error Loading Encounters</h1>
         <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
  // loader: ({context, params}) =>{
  //    console.log('params',context,params)
  //   // context.queryClient.ensureQueryData(encounterQueryOptions({}))
  // }
})

function RouteComponent() {
  return <main role="main" aria-label="weight loss content" className="min-h-screen w-full"><EncountersPage /></main>
}
